import React from "react";
import { useTranslation } from "react-i18next";

import { FacilityReportReviewsData } from "../../../../models/FacilityReportData";
import { ExtendedReviewSummary } from "../../../FacilityReviewSummariesComponents/ExtendedReviewSummary";

interface IReviewsSectionProps {
  reviews?: FacilityReportReviewsData;
}

export const ReviewsSection: React.FunctionComponent<IReviewsSectionProps> = (
  props
) => {
  const { t: _t } = useTranslation();
  const t = (key: string) =>
    _t(`facilityReportsPage.facilityReportDetails.${key}`);
  const { reviews } = props;

  if (!reviews) {
    return null;
  }

  return (
    <div className="reviews-section white-border-panel facility-report-details-section">
      <div
        className="inner-container"
        id="facility-report-details-reviews-section"
      >
        <h2>{t("reviewsSection.title")}</h2>
        {!reviews.review_summary ? (
          <p className="no-data-message">{t("no_data")}</p>
        ) : (
          <ExtendedReviewSummary
            locationTitle={undefined}
            reviewSummary={reviews.review_summary}
            showDownloadButtons={false}
          />
        )}
      </div>
    </div>
  );
};
